import { render } from "./botonAyahuasca.vue?vue&type=template&id=b530a736"
import script from "./botonAyahuasca.vue?vue&type=script&lang=js"
export * from "./botonAyahuasca.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\webencusco\\projects\\fronted-carta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__